export default () => {
  const isMedicalEmergency = $("#is-medical-emergency-subtype");
  const isMedicalEmergencyContainer = $(".medical-emergency-checkbox-container");
  const medicalEmergencySubtypes = [
    "#incident_report_incident_is_medical_emergency_subtype_emergency_no_EMS_call",
    "#incident_report_incident_is_medical_emergency_subtype_emergency_resulting_in_de",
    "#incident_report_incident_is_medical_emergency_subtype_overdose_not_death",
    "#incident_report_incident_is_medical_emergency_subtype_overdose_death",
    "#incident_report_incident_is_medical_emergency_subtype_emergency_EMS_called"
  ];

  // Uncheck all other subtypes when one is checked
  medicalEmergencySubtypes.forEach((subtype) => {
    $(document).on("click", subtype, () => {
      medicalEmergencySubtypes.forEach((otherSubtype) => {
        if (otherSubtype !== subtype) {
          $(otherSubtype).prop("checked", false);
        }
      });
    });
  });

  // Check if any of the medical emergency subtypes are checked
  const isAnySubtypeChecked = () =>
    medicalEmergencySubtypes.some((subtype) => $(subtype).is(":checked"));

  // If any subtype is checked, check the isMedicalEmergency by default
  if (isAnySubtypeChecked()) {
    isMedicalEmergency.prop("checked", true);
  }

  if (!isMedicalEmergency.is(":checked")) {
    isMedicalEmergencyContainer.hide();
  }

  isMedicalEmergency.on("change", () => {
    if (isMedicalEmergency.is(":checked")) {
      isMedicalEmergencyContainer.show();
    } else {
      // uncheck all of the inputs inside container
      isMedicalEmergencyContainer.find('input[type="checkbox"]').prop("checked", false);
      isMedicalEmergencyContainer.find('input[type="checkbox"]').each(function () {
        $(this).trigger("change");
      });

      isMedicalEmergencyContainer.hide();
    }
  });
};
